import { render } from "./glob-spinner.vue?vue&type=template&id=45f9f416"
import script from "./glob-spinner.vue?vue&type=script&lang=js"
export * from "./glob-spinner.vue?vue&type=script&lang=js"

import "./glob-spinner.vue?vue&type=style&index=0&id=45f9f416&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__